import type {AiAnimationSourceType} from '@Libraries/ai-poster-animation.library';
import type {GenerateAiVideoParams} from '@Libraries/ai-video.library';
import type {GenerateImageParams} from '@Libraries/pmw-stock-media-library';
import type {AiVideoQuality} from '@Panels/ai-video-panel/ai-video-panel.types';
import type {AiImageAspectRatioOptions} from '@Panels/ai-image-panel/ai-image-panel.types';

export enum AiImageState {
  IDLE = 'IDLE',
  GENERATING = 'GENERATING',
  READY = 'READY',
}

export enum AiSubtitleState {
  IDLE = 'IDLE',
  GENERATING = 'GENERATING',
  READY_SUCCESS = 'READY_SUCCESS',
  READY_FAILED = 'READY_FAILED',
}

export enum AiVoiceState {
  IDLE = 'IDLE',
  GENERATING = 'GENERATING',
  READY = 'READY',
  ERROR = 'ERROR',
}

export enum AiVideoGenerationStatus {
  PENDING = 'PENDING',
  GENERATING = 'GENERATING',
  ERROR = 'ERROR',
}

export interface AiVideosState {
  id: string;
  status: AiVideoGenerationStatus;
  params: GenerateAiVideoParams;
  errorCode?: string;
}

export enum PosterAnimationGenerationStatus {
  GENERATING = 'GENERATING',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
}

export interface PosterAnimationItemSource {
  itemUid: string;
  sourceItemType: string;
}

export interface PosterAnimationGenerationParams {
  quality: AiVideoQuality;
  generateAudio: boolean;
  prompt: string;
  sourceType: AiAnimationSourceType;
  itemSource: PosterAnimationItemSource | null;
}

export interface PosterAnimationGenerationState {
  id: string;
  status: PosterAnimationGenerationStatus;
  width: number;
  height: number;
  params: PosterAnimationGenerationParams;
  errorCode?: string;
}

export interface AiImageEditState {
  itemUid: string;
  generationId: string;
  sourceHashedFilename: string;
  sourceWidth: number;
  sourceHeight: number;
}

export interface AiImageGenerationState {
  id: string;
  aspectRatio: AiImageAspectRatioOptions;
}

export enum AiImageGenerationFailureStatus {
  ERROR = 'ERROR',
  PENDING_RETRY = 'PENDING_RETRY',
}

export interface AiImageGenerationFailureState {
  id: string;
  status: AiImageGenerationFailureStatus;
  aspectRatio: AiImageAspectRatioOptions;
  params: GenerateImageParams;
  errorCode?: string;
}

export interface AiState {
  aiImage: AiImageState;
  aiSubtitles: AiSubtitleState;
  aiVoice: AiVoiceState;
  aiVideo: AiVideosState[];
  aiImageEdit: AiImageEditState[];
  aiImageGenerations: AiImageGenerationState[];
  aiImageGenerationFailures: AiImageGenerationFailureState[];
  aiPosterAnimation: PosterAnimationGenerationState[];
  aiCredits: number | null;
}
